/**
 * Determines whether lead video should preroll based on subscription status.
 * Non-lead videos excluded.
 * @param {boolean} isLead
 * @param {boolean} subscriber
 * @param {Object} videoData
 * @returns {boolean}
 */
export function shouldLeadPreroll(isLead, subscriber) {
  if (!isLead || subscriber) return false;

  return true;
}
